// extracted by mini-css-extract-plugin
export default {"page":"n3-z","cartModal":"o3-z","checkout":"p3-z","placeholder":"q3-z","account":"r3-z"};